import { render, staticRenderFns } from "./AdminTop.vue?vue&type=template&id=2025e09c&scoped=true"
import script from "./AdminTop.vue?vue&type=script&lang=js"
export * from "./AdminTop.vue?vue&type=script&lang=js"
import style0 from "./AdminTop.vue?vue&type=style&index=0&id=2025e09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025e09c",
  null
  
)

export default component.exports